import React from "react"
import styled from "styled-components"
import CommunityCommentsCount from "../../../components/common/community-comments-count/community-comments-count.component"
import { useCommentsData } from "../../../components/common/community-comments-count/use-comments"
import { News } from "./news.interface"
import { NeutralTextLink } from "../link/link.styled"
import { Image } from "../../../components/common/image.component"
import { generateSources } from "../../../helpers/images"
import { AppFunctionComponent } from "../../../types"
import { css } from "styled-components"

const NewsBox = styled.li<{ $fullHeight?: boolean }>`
  width: 100%;
  display: flex;
  max-width: 400px;
  overflow: hidden;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.size.borderRadius};
  background-color: ${({ theme }) => theme.color.background};
  ${({ $fullHeight }) =>
    $fullHeight &&
    css`
      height: 100%;
    `}
`

const NewsHeading = styled.div`
  padding: 15px 30px 0;
`

const NewsImage = styled(Image)`
  height: 285px;
  width: 100%;
  background-size: cover;
  background-position: center;

  img {
    object-fit: cover;
    object-position: center;
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    height: 0;
    padding-bottom: 78%;
  }
`

const NewsContent = styled.div`
  flex: 1;
  display: flex;
  padding: 0 30px 15px;
  flex-direction: column;
`

const NewsDescription = styled.p`
  flex: 1;
  margin: 10px 0;
  min-height: 6em;
  border-bottom: 1px solid ${({ theme }) => theme.color.border};
  padding-bottom: 15px;
`

const NewsItem: AppFunctionComponent<News> = ({
  content,
  communityLink,
  fullHeight,
  link,
  title,
  mobileImage,
  desktopImage,
}) => {
  const [communityPostId] = /\d+$/.exec(communityLink) || [null]
  const { count } = useCommentsData(Number(communityPostId) || 0)

  return (
    <NewsBox $fullHeight={fullHeight}>
      <NeutralTextLink to={`/community/blog/${link}`}>
        <NewsImage
          image={generateSources([[desktopImage], [mobileImage, 768]])}
        />
        <NewsHeading>Blog: {title}</NewsHeading>
      </NeutralTextLink>
      <NewsContent>
        <NewsDescription>{content}</NewsDescription>
        <NeutralTextLink to={communityLink}>
          {communityPostId && <CommunityCommentsCount count={count} />}
        </NeutralTextLink>
      </NewsContent>
    </NewsBox>
  )
}

export default NewsItem
